import { Nullable, ValidatorEmail } from "@/core/types";

/**
 * Валидация email адреса
 * 
 * Проверяет:
 * - Наличие @ и домена с точкой
 * - Отсутствие пробелов
 * - Корректные символы в локальной части и домене
 * - Домен верхнего уровня (минимум 2 символа)
 * - Отсутствие точек в начале/конце и подряд
 * 
 * @param val - Email для проверки
 * @param params - Дополнительные параметры валидации
 * @param returnMessage - Возвращать сообщение об ошибке вместо false
 * @returns true если валиден, false или сообщение об ошибке если нет
 */
export default function checkEmail(val: Nullable<string>, params: Omit<ValidatorEmail, 'type'> = {}, returnMessage = false) {
    const email = (val || '').trim();
    
    if (!email) {
        return returnMessage ? 'email обязателен' : false;
    }
    
    // RFC 5322 compliant regex (упрощенная версия)
    // Проверяет:
    // - локальная часть: буквы, цифры, точки, дефисы, подчеркивания
    // - @ обязателен
    // - домен: буквы, цифры, дефисы, точки
    // - TLD: минимум 2 буквы
    const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    
    const isValid = emailRegex.test(email);
    
    return isValid ? true : (returnMessage ? 'неверный формат email' : false);
}

